export default {
  title: 'Verzoeken tot gegevensverwijdering',
  fields: {
    created_at: 'Aangevraagd op',
    restaurant: 'Restaurant',
    customer: 'Klant',
    note: 'Notitie',
    status: 'Status',
    completed_by: 'Voltooid door',
    actions: 'Acties',
  },
  statuses: {
    pending: 'In behandeling',
    completed: 'Voltooid',
  },
  buttons: {
    approve: 'Goedkeuren',
  },
  modals: {
    approve: {
      title: 'Gegevensverwijdering goedkeuren voor {{name}}?',
      description:
        'Dit verwijdert de persoonlijke gegevens van de klant permanent en kan niet ongedaan worden gemaakt. Het verzoek wordt gemarkeerd als voltooid.',
    },
  },
  toasts: {
    failed_to_load_data: 'Gegevens laden mislukt',
    failed_to_approve: 'Verzoek goedkeuren mislukt',
    approved: 'Verzoek goedgekeurd en gegevens verwijderd',
  },
};
